'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { IconChevronDown } from './DesignIcons';

export default function HeaderNav({ onOpenContact }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [programsDropdown, setProgramsDropdown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const programs = [
    { name: 'Individuals', href: '#programs' },
    { name: 'Schools', href: '#programs' },
    { name: 'Colleges', href: '#programs' },
    { name: 'Parents & Families', href: '#programs' },
    { name: 'Corporates', href: '#programs' },
    { name: 'Groups', href: '#programs' },
  ];

  return (
    <header className={`header-nav ${scrolled ? 'header-scrolled' : ''}`}>
      <div className="header-container">
        {/* Brand Logo */}
        <Link href="/" className="header-logo" onClick={() => setMobileMenuOpen(false)}>
          <Image
            src="/logo.png"
            alt="InnerTruth — Enriching Lives"
            width={185}
            height={46}
            priority
            className="logo-img"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav" aria-label="Main Navigation">
          <Link href="/" className="nav-item active-nav">
            Home
            <span className="active-indicator"></span>
          </Link>

          <Link href="/about" className="nav-item">
            About Us
          </Link>

          {/* Programs Dropdown */}
          <div 
            className="nav-item dropdown-trigger"
            onMouseEnter={() => setProgramsDropdown(true)}
            onMouseLeave={() => setProgramsDropdown(false)}
          >
            <span className="dropdown-label">
              Programs
              <IconChevronDown className="dropdown-chevron" />
            </span>

            {programsDropdown && (
              <div className="nav-dropdown-menu">
                {programs.map((p) => (
                  <a
                    key={p.name}
                    href={p.href}
                    className="dropdown-link"
                    onClick={() => setProgramsDropdown(false)}
                  >
                    {p.name}
                  </a>
                ))}
              </div>
            )}
          </div>

          <a href="#six-steps" className="nav-item">
            The 6 Steps
          </a>

          <a href="#the-book" className="nav-item">
            The Book
          </a>

          <a href="#testimonials" className="nav-item">
            Testimonials
          </a>

          <a href="#contact" className="nav-item">
            Contact
          </a>
        </nav>

        {/* CTA Button */}
        <div className="header-actions">
          <button
            type="button"
            className="btn-get-in-touch"
            onClick={onOpenContact}
          >
            Get in Touch
          </button>

          {/* Mobile Menu Toggle */}
          <button
            type="button"
            className="mobile-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            <span className={`bar ${mobileMenuOpen ? 'bar-1-open' : ''}`}></span>
            <span className={`bar ${mobileMenuOpen ? 'bar-2-open' : ''}`}></span>
            <span className={`bar ${mobileMenuOpen ? 'bar-3-open' : ''}`}></span>
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      {mobileMenuOpen && (
        <div className="mobile-drawer">
          <Link href="/" className="mobile-link" onClick={() => setMobileMenuOpen(false)}>
            Home
          </Link>
          <Link href="/about" className="mobile-link" onClick={() => setMobileMenuOpen(false)}>
            About Us
          </Link>
          <div className="mobile-section-header">Programs:</div>
          <div className="mobile-sublinks">
            {programs.map((p) => (
              <a
                key={p.name}
                href={p.href}
                className="mobile-sublink"
                onClick={() => setMobileMenuOpen(false)}
              >
                • {p.name}
              </a>
            ))}
          </div>
          <a href="#six-steps" className="mobile-link" onClick={() => setMobileMenuOpen(false)}>
            The 6 Steps
          </a>
          <a href="#the-book" className="mobile-link" onClick={() => setMobileMenuOpen(false)}>
            The Book
          </a>
          <a href="#testimonials" className="mobile-link" onClick={() => setMobileMenuOpen(false)}>
            Testimonials
          </a>
          <a href="#contact" className="mobile-link" onClick={() => setMobileMenuOpen(false)}>
            Contact
          </a>

          <button
            type="button"
            className="btn-get-in-touch mobile-cta-btn"
            onClick={() => {
              setMobileMenuOpen(false);
              onOpenContact();
            }}
          >
            Get in Touch
          </button>
        </div>
      )}
    </header>
  );
}
